import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store, StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EffectsModule } from '@ngrx/effects';
import { WaitingroomEffects } from './store/waitingroom.effect';
import { waitingroomReducer } from './store/waitingroom.reducer';
import { AppointmentModule } from '../appointment/appointment.module';
import { LogAppointmentService } from '../logging/providers/log-appointment.service';
import { BrandingModule } from '../branding/branding.module';
import { InstitutionSettingsModule } from '../institution-settings/institution-settings.module';
import { WaitingroomComponent } from './single-user-waitingroom/waitingroom.component';
import { MultiUserWaitingroomComponent } from './multi-user-waitingroom/multi-user-waitingroom.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        StoreModule.forFeature('waitingroom', waitingroomReducer),
        EffectsModule.forFeature([WaitingroomEffects]),
        AppointmentModule,
        BrandingModule,
        NgbPaginationModule,
        WaitingroomComponent,
        MultiUserWaitingroomComponent
    ],
    providers: [
        Store,
        LogAppointmentService,
        InstitutionSettingsModule
    ],
    exports: []
})

export class WaitingroomModule {
}
